<script>
  import {mapGetters} from 'vuex'

  export default {
    name: 't-text',
    props: {
      tag: {
        type: String,
        default: 'span',
        validator: v => ['span', 'p'].indexOf(v) !== -1
      },
      size: {
        type: String,
        default: 'lg',
        validator: v => ['sm', 'md', 'lg', 'xl'].indexOf(v) !== -1
      },
      color: {
        type: String,
        default: 'inherit',
        validator: v =>
          [
            'black',
            'white',
            'concrete',
            'platinum',
            'silver',
            'gray',
            'granite',
            'black',
            'yellow',
            'blue',
            'green',
            'orange',
            'purple',
            'red',
            'inherit',
            'unset'
          ].indexOf(v) !== -1
      },
      branded: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      ...mapGetters(['themeColorHEX']),
      textClassList() {
        const classObj = {
          sm: ['text-12 leading-4'],
          md: ['text-14 leading-5'],
          lg: ['text-16 leading-5'],
          xl: ['text-18 leading-5.5']
        }

        return [...classObj[this.size], !(this.branded && this.themeColorHEX) && [this.color !== 'unset' ? `text-${this.color}` : '']]
      }
    },
    render(h) {
      const tag = this.tag
      const brandColor = this.branded && this.$helpers.getCorrectColor(this.themeColorHEX)

      return h(
        tag,
        {
          ref: this.ref,
          class: this.textClassList,
          style: brandColor ? {color: brandColor} : {}
        },
        this.$slots.default
      )
    }
  }
</script>
